




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import BigNumber from 'bignumber.js';
import SelectBreedingPopup from '@/components/SelectBreedingPopup.vue';
import {
  validateAccount,
  allowance,
  hatchingALPACost, increaseAllowance, hatchWithAuto, balanceOf } from '@/utils/web3';
import { alpaUnit } from '@/utils/unit';
import { EventBus } from '@/utils/EventBus';
import { Alpaca } from '@/backend/type';
import { alpacaContractAddress } from '@/utils/web3';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
    SelectBreedingPopup,
  },
})
export default class Breeding extends Vue {
  @Prop({
    required: false,
    type: String,
  })
  public selectedAlpaca!: string;

  public showSelectPopup: boolean = false;
  public sire: Alpaca | null = null;
  public matron: Alpaca | null = null;
  public allowanceAmount: number = -1;
  public breedingCost: number = 0;
  public approveLoading: boolean = false;
  public curParent: 'sire' | 'matron' = 'sire';
  public alpaBalance: BigNumber = new BigNumber(0);

  get account() {
    return this.$store.getters.getAccount;
  }

  get showApprove() {
    if (this.allowanceAmount === - 1 || !this.breedingCost || this.allowanceAmount >= this.breedingCost) {
      return false;
    }
    return true;
  }

  get breedingCostAfterUnit() {
    // return alpaUnit(this.breedingCost);
    return this.breedingCost;
  }

  get canBreed() {
    return (
      this.sire &&
      this.matron &&
      this.breedingCost &&
      this.allowanceAmount >= this.breedingCost &&
      this.alpaBalance.isGreaterThanOrEqualTo(this.breedingCost)
    );
  }

  public async mounted() {
    EventBus.$on('approve-status', this.onApproveStatus);
    this.getCurAllowance();
    this.breedingAlpaCost();
    this.getAlpaBalance();

    if (this.selectedAlpaca) {
      this.sire = JSON.parse(this.selectedAlpaca);
    }
  }

  public beforeDestroy() {
    EventBus.$off('approve-status', this.onApproveStatus);
  }

  public async getAlpaBalance() {
    const amount = await balanceOf(this.account);
    if (amount) {
      this.alpaBalance = new BigNumber(amount);
    }
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public togglePopup() {
    this.showSelectPopup = !this.showSelectPopup;
  }

  public async getCurAllowance() {
    this.allowanceAmount = Number(await allowance(this.account, alpacaContractAddress!));
  }

  public async breedingAlpaCost() {
    if (!this.sire || !this.matron) {
      return;
    }
    this.breedingCost = Number(await hatchingALPACost(Number(this.sire.id), Number(this.matron.id)));
  }

  public async handleApprove() {
    if (!this.account) {
      return;
    }
    this.approveLoading = true;
    increaseAllowance(this.account, alpacaContractAddress!, 10000000);
  }

  public async onApproveStatus(status: 'approving' | 'completed' | 'error') {
    // if (status === 'approving') {
    //   this.approveLoading = true;
    // }
    if (status === 'completed') {
      await this.getCurAllowance();
      this.approveLoading = false;
    }
    if (status === 'error') {
      this.approveLoading = false;
    }
  }

  public async handleBreeding() {
    if (!this.account) {
      return;
    }
    if (!this.sire || !this.matron) {
      return;
    }
    hatchWithAuto(
      Number(this.sire.id),
      Number(this.matron.id),
      this.account,
    );
  }

  public selectParent(parent: 'sire' | 'matron') {
    this.curParent = parent;
    this.togglePopup();
  }

  public clickAlpacaCard({alpaca, parent}: {alpaca: Alpaca, parent: 'sire' | 'matron'}) {
    if (this.curParent === 'sire') {
      this.sire = alpaca;
    } else {
      this.matron = alpaca;
    }
  }

  public alpaUnit(num: number | string) {
    return alpaUnit(num);
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getCurAllowance();
      this.getAlpaBalance();
    }
  }

  @Watch('sire.id', {immediate: true})
  public onSire(val: string) {
    if (val) {
      this.breedingAlpaCost();
    }
  }

  @Watch('matron.id', {immediate: true})
  public onMatron(val: string) {
    if (val) {
      this.breedingAlpaCost();
    }
  }
}
